import { render } from "./GymPbTab.vue?vue&type=template&id=30e1b731&scoped=true"
import script from "./GymPbTab.vue?vue&type=script&lang=js"
export * from "./GymPbTab.vue?vue&type=script&lang=js"

import "./GymPbTab.vue?vue&type=style&index=0&id=30e1b731&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e1b731"]])

export default __exports__